import moment from 'moment-timezone';

const EASTERN = 'America/New_York';

// UTC (no Z) → Eastern display
export const formatEasternDateTimeFromUtc = (val) =>
  val ? moment.utc(val).tz(EASTERN).format('MM/DD/YYYY h:mm A') : '—';

// Already correct wall time — do not treat as UTC
export const formatEasternDateTime = (val) =>
  val ? moment(val).format('MM/DD/YYYY h:mm A') : '—';

export const formatEasternDate = (val) =>
  val ? moment(val).format('MM/DD/YYYY') : '—';
